// libs
import styled from 'styled-components'
// components
import { Scrollbar } from 'components/UI'
// icons
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
// themes
import { colors } from 'themes'
// utils
import { size, transparentize } from 'polished'

const ButtonWrapper = styled.div`
  align-items: center;
  background: ${transparentize(0.2, colors.white)};
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 64px;
  padding: 16px;
  position: relative;
`

const CardHeader = styled.div<{ backgroundColor: string }>`
  align-items: center;
  background: ${({ backgroundColor }) => backgroundColor || colors.darkBlue500};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  color: ${colors.white100};
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  width: 100%;
`

const CardText = styled.div`
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 16px;
`

const CardWrapper = styled.div`
  background: ${colors.white100};
  border-radius: 4px;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.2),
    0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 0 0 0 rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`

const ChipWrapper = styled.div``

const MenuItem = styled.div`
  align-items: center;
  background: ${colors.white};
  border-radius: 20px;
  color: ${colors.blue500};
  cursor: pointer;
  display: flex;
  margin: 8px 0;
  padding: 4px 8px;
`

const Wrapper = styled(Scrollbar)`
  height: 100%;
  width: 100%;
  padding: 16px 32px 16px 16px;
`

const DotsIcon = styled(DotsIconOrigin)`
  && {
    position: absolute;
    bottom: 4px;
    right: 8px;
    cursor: pointer;
    ${size('25px')};
  }
`

export { ButtonWrapper, CardContent, CardHeader, CardText, CardWrapper, ChipWrapper, MenuItem, Wrapper, DotsIcon }
